import cx from 'classnames';
import React, { CSSProperties, ReactNode, useRef, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import { useResizeObserver } from '../../../utils/hooks';
import { EDITOR_TYPES } from '../robot.types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot__field.module.scss';

interface FieldScaleProps {
    children: ReactNode;
    style?: CSSProperties;
    className?: string;
    editor?: EDITOR_TYPES | null;
}

const scaleRefContext = React.createContext({ current: 1 } as React.MutableRefObject<number>);
export const useScaleRefContext = () => React.useContext(scaleRefContext);

const FieldScale = ({ children, editor, style, className }: FieldScaleProps) => {
    const boundsRef = useRef<HTMLDivElement>(null);
    const ref = useRef<HTMLDivElement>(null);
    const scaleRef = useRef<number>(1);

    const isCodeLigthV2 = editor && editor === EDITOR_TYPES.CODE_LIGHT_V2;

    const updateScale = () => {
        if (ref.current && boundsRef.current) {
            const scale = Math.min(
                1,
                boundsRef.current.offsetWidth / ref.current.offsetWidth,
                boundsRef.current.offsetHeight / ref.current.offsetHeight
            );
            scaleRef.current = scale;
            ref.current.style.transform = `scale(${scale})`;
        }
    };

    useResizeObserver(boundsRef, updateScale);
    useResizeObserver(ref, updateScale);

    const [init, setInit] = useState(false);
    useIsomorphicLayoutEffect(() => {
        updateScale();
        setInit(true);
    }, []);

    return (
        <scaleRefContext.Provider value={scaleRef}>
            <div className={cx(styles.bounds, className)} ref={boundsRef} style={style}>
                <div
                    className={cx(
                        styles.field_wrapper,
                        { [styles.field_wrapper_v2]: isCodeLigthV2 },
                        'qa_robot-field-wrapper'
                    )}
                    ref={ref}
                    style={init ? {} : { opacity: 0 }}
                >
                    {children}
                </div>
            </div>
        </scaleRefContext.Provider>
    );
};

export default FieldScale;
